<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <p class="page-title">Error!</p>
        <p class="order-confimation-description">
            Your order has encountered the following error in submission:
        </p>
        <div class="row">
            <div class="col-lg-8 offset-lg-2" style="border: 3px solid red; padding-top:20px; padding-bottom:20px">
                {{orderDetails.errorMessage}}
            </div>
        </div>
        <p class="order-confimation-description">
           Your error has been saved as a pending-error order
        </p>
        <br>
        <p class="order-confimation-description">
            If you believe you know the cause of the error you may edit the order 
            and try submitting it again. If you're not sure, the support team has 
            been notified of the error and will review the order in the next 2-3 business days. 
            This order can also be edited or deleted from the Track Order page at any time.
            If this is an urgent order, please click <a href="#" @click="ShowHelpForm()">here</a> to contact us.
        </p>
    </div>
</template>
<script>
    export default {
        props:['orderDetails'],
        components: {},
        data(){
            return{
            }
        },
        methods: {
            ShowHelpForm(){
                document.body.classList.add("body-overflow");
                this.$emit('clicked');
            }
        },
        created(){
            
        }
    }
</script>



// WEBPACK FOOTER //
// OrderError.vue?10995b94